import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogButton = styled(Button)(() => ({
  width: '264px',
  height: '56px',
  borderRadius: '10px',
  '@media (max-height: 820px)': {
    height: '48px',
  },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    maxWidth: 'none',
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const DialogTitle = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '24px',
  fontWeight: '600',
  margin: '4px 0 20px',
  textTransform: 'capitalize',
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: '500px',
  maxWidth: '540px',
  minHeight: '400px',
  padding: '40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  right: '20px',
  top: '20px',
  position: 'absolute',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const ButtonsSpace = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '20px',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '200px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  '&:active': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  maxWidth: '200px',
  textTransform: 'lowercase',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
  '&:active': {
    backgroundColor: theme.palette.secondary.main,
  },
}));
